import { render, staticRenderFns } from "./OtherServices.vue?vue&type=template&id=7c451a2f&scoped=true&"
import script from "./OtherServices.vue?vue&type=script&lang=js&"
export * from "./OtherServices.vue?vue&type=script&lang=js&"
import style0 from "./OtherServices.vue?vue&type=style&index=0&id=7c451a2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c451a2f",
  null
  
)

export default component.exports